import { configureStore } from '@reduxjs/toolkit';
import dashboardReducer from '../features/Dashboard/DashboardSlice';
import authReducer from './Slices/AuthSlice';
import fileReducer from './Slices/FileSlice';
import issuesReducer from "./Slices/IssuesSlice";
import maintenanceReducer from './Slices/MaintenanceSlice';
import permissionReducer from './Slices/PermissionSlice';
import serviceReducer from './Slices/ServiceSlice';
import tyreReducer from './Slices/TyreSlice';
import userReducer from './Slices/UserSlice';
import workOrderReducer from './Slices/WorkOrderSlice';
import notificationReducer from './Slices/NotificationSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    maintenance: maintenanceReducer,
    tyre: tyreReducer,
    users: userReducer,
    permissions: permissionReducer,
    services: serviceReducer,
    files: fileReducer,
    issues: issuesReducer,
    workOrder: workOrderReducer,
    notifications: notificationReducer
  },
});